<template>
  <div class="newsItem" @click="toDetail">
    <span class="val elli">{{detail.name}}</span>
  </div>
</template>

<script>
  export default {
    props: {
      detail: {
        name: '',
        time: ''
      }
    },
    methods: {
      toDetail() {
        this.$emit('ok')
      }
    },
  }
</script>

<style lang="scss" scoped>
  .newsItem {
    margin-left: 0.08rem;
    padding: 0.8em 0;

    .val {
      font-size: .16rem;
      position: relative;
      min-width: 0;
      padding-left: .12rem;
      cursor: pointer;

      &::after {
        content: "";
        display: block;
        width: .03rem;
        height: .03rem;
        background-color: #333;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .val:hover .val {
      color: #2F915D;
    }

    .val:hover .val::after {
      background-color: #2F915D;
    }
  }
  @media only screen and (max-width: 767px) {
    .newsItem{
      .val{font-size:0.24rem}
    }
  }
</style>